export default __webpack_public_path__ + "static/media/greenTickInPricing.5a291966.svg";